import { apiBase, tunnelApiBase } from "../../config";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const api = createApi({
	baseQuery: fetchBaseQuery({
		baseUrl: "/api/v1",
		prepareHeaders: async (headers) => {
			return headers;
		},
	}),
	keepUnusedDataFor: 0.001,

	endpoints: () => ({}),
	reducerPath: "api",
	tagTypes: [],
});
